import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const accountSearchResultMobileUsersSlice = getCachedTableDataSlice<
    Record<string, number>,
    AccountSearchCriteria,
    AccountSortField,
    AccountSearchFiltering
>('accountSearchResultMobileUsers');

export const accountSearchResultMobileUsersActions = accountSearchResultMobileUsersSlice.actions;

const accountSearchResultMobileUsersCacheSelector: CachedTableCacheSelector<Record<string, number>>
    = state => state.accountSearchResult.mobileUsers.cache;
export const accountSearchResultMobileUsersDataSelector: CachedTableDataSelector<Record<string, number>>
    = state => state.accountSearchResult.mobileUsers;
export const accountSearchResultMobileUsersResultSelector = getCachedTableResultSelector(
    accountSearchResultMobileUsersCacheSelector,
    accountSearchResultStateSelector,
);
